/**
 * @file index.tsx
 * @brief Einstiegspunkt der React-Anwendung.
 *
 * Diese Datei initialisiert die React-Anwendung, rendert die Hauptkomponente (`App`)
 * in das DOM und konfiguriert die Web Vitals Berichterstattung.
 *
 * @param {HTMLElement} rootElement - Das HTML-Element, in das die React-Anwendung gerendert wird.
 * @returns {void}
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import App from './App';
import reportWebVitals from './utils/reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
